import Env from '@/env/env'

export const preloadGoogleMaps = () => {
  if (typeof window === 'undefined') return
  if ((window as Window & { google?: { maps?: unknown } }).google?.maps) return

  const apiKey = Env.GOOGLE_KEY as string | undefined
  if (!apiKey) return

  const existing = document.querySelector<HTMLScriptElement>(
    'script[data-google-maps-loader]',
  )
  if (existing) return

  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`
  script.async = true
  script.defer = true
  script.setAttribute('data-google-maps-loader', 'true')
  document.head.appendChild(script)
}
